import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

import Button from 'components/CustomButtons/Button';

import tutorials from 'components/Stepper/tutorials';
import style from './style/style';

class Tutorial extends Component {
  state = {
    finished: false,
    stepIndex: 0,
  };

  handleNext = () => {
    const { stepIndex } = this.state;

    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= 2,
    });
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  renderStepActions = (step) => {
    return (
      <div style={{ margin: '12px 0' }}>
        <Button onClick={this.handlePrev} color='primaryNoBackground' disabled={step === 0}>
          Précédent
        </Button>

        <Button onClick={this.handleNext} color='primary'>
          {step === 2 ? 'Terminé' : 'Suivant'}
        </Button>
      </div>
    );
  };

  generateSteps = () => {
    const { classes, type, color } = this.props;
    const steps = [];

    type &&
      tutorials[type].tutorial.map((element, index) => {
        return steps.push(
          <Step key={`step-${index}`}>
            <StepLabel
              classes={{
                label: classes.title,
              }}
              StepIconProps={{
                classes: {
                  root: classes[color],
                },
              }}>
              {element.title}
            </StepLabel>
            <StepContent>
              <p dangerouslySetInnerHTML={{ __html: element.text }}></p>
              {this.renderStepActions(index)}
            </StepContent>
          </Step>,
        );
      });

    return steps;
  };

  render() {
    const { classes } = this.props;
    const { finished, stepIndex } = this.state;

    return (
      <div className={classes.container}>
        <Stepper activeStep={stepIndex} orientation='vertical'>
          {this.generateSteps()}
        </Stepper>

        {finished && (
          <p className={classes.finishedContainer}>
            <a
              onClick={(event) => {
                event.preventDefault();
                this.setState({ stepIndex: 0, finished: false });
              }}
              className={classes.finishedText}>
              Cliquez ici pour recommencer le tutoriel
            </a>
          </p>
        )}
      </div>
    );
  }
}

Tutorial.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default withStyles(style)(Tutorial);
